export interface MappedWagerToggle {
  name: string;
  active: boolean;
  type?: string;
  slotCount?: number;
}

export function applyMappedWagerTypes(
  wagerTypes: MappedWagerToggle[],
  mapped: Array<{ type?: string; slotCount?: number }> | null | undefined
): void {
  if (!mapped || mapped.length === 0) {
    return;
  }
  for (const toggle of wagerTypes) {
    toggle.active = mapped.some(
      m => m.slotCount === toggle.slotCount && m.type === toggle.type
    );
  }
}
